module.exports = __webpack_public_path__ + "static/media/presence.3d1e395f.svg";